import Cookies from "js-cookie";

function updateConsent(consent: boolean) {
    Cookies.set("localcookieconsent", consent.toString(), { path: "/", expires: 180 });
}

export default function useHasCookieConsent(): [boolean | undefined, typeof updateConsent] {
    const hasConsent = Cookies.get("localcookieconsent");
    console.debug("READ CONSENT", hasConsent)
    if (hasConsent !== undefined) {
        return [hasConsent === "true", updateConsent];
    }
    return [undefined, updateConsent];
}